import Shortcut from "./Shortcut";

export default Shortcut;
